export default {
      id: "favorite-usage",
      viewBox: "0 0 20 27",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#favorite",
      toString: function () {
        return this.url;
      }
    }